const BASE_CAMPAIGN_PATH = '/brand';

export const campaignGETPath = (brandId: string | number) => `${BASE_CAMPAIGN_PATH}/${brandId}/campaign`;

export const campaignGETByIDPath = (brandId: string | number, campaignId: string | number) =>
  `${BASE_CAMPAIGN_PATH}/${brandId}/campaign/${campaignId}`;

export const campaignRedirectUrlPOSTPath = (brandId: string | number, campaignId: string | number) =>
  `${BASE_CAMPAIGN_PATH}/${brandId}/campaign/${campaignId}/redirect-url`;
